import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {Location} from '@angular/common';
import { CardService } from 'app/modules/card/services/card.service';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { InputPatterns } from 'app/shared/helper/input-patterns';

@Component({
  selector: 'esim-form',
  templateUrl: './esim-form.component.html',
  styleUrls: ['./esim-form.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class EsimFormComponent implements OnInit {
  public showLoader: boolean = false;
  isChecked: boolean = false; 

  firstName: string;
  lastName: string;
  email: string;
  mobileNo: string;
  address: string;
  state: string;
  city: string;
  simType: string;
  airTicket: string;
  visa: string;
  panCard: string;
  orderType: string;
  orderData: any;
  eSIMSelectedPackage: any;
  public consumerDetail;
  public addressPattern = InputPatterns.ADDRESS_PATTERN;
  public addressPatternOnInput = InputPatterns.ADDRESS_PATTERN_ONINPUT;

    iosItems: string[] = [
      'iPhone 16, 16 Plus, 16 Pro, 16 Pro Max',
      'iPhone 15, Plus, Pro, Pro Max',
      'iPhone 14, Pro, Pro Max, Plus',
      'iPhone 13, Mini, Pro, Pro Max',
      'iPhone 12, Mini, Pro, Pro Max',
      'iPhone 11, Pro, Pro Max',
      'iPhone XS, XS Max, XR',
      'iPhone SE (2020, 2022)'
    ];
    
    androidItems: string[] = [
      'Galaxy S23, S23+, S23 Ultra',
      'Galaxy S22, S22+, S22 Ultra',
      'Galaxy S21, S21+, S21 Ultra, 5G',
      'Galaxy S20, S20+, S20+ 5G, S20 Ultra 5G, S20 Ultra',
      'Galaxy Note 20',
      'Galaxy Z',
      'Galaxy Note 20 Ultra',
      'Galaxy A54 5G',
      'Pixel 2, 2 XL',
      'Pixel 3, 3 XL, 3a, 3a XL',
      'Pixel 4, 4a, 4 XL',
      'Pixel 5, 5a',
      'Pixel 6, 6a, 6 Pro',
      'Pixel 7, 7a, 7 Pro',
      'Pixel 8, 8 Pro',
      'Pixel Fold',
      'OPPO Find X3 Pro',
      'OPPO Find N2 Flip',
      'OPPO Reno 5A',
      'OPPO Reno 6 Pro 5G',
      'OPPO Reno 9A',
      'OPPO Find X5, Find X5 Pro',
      'OPPO A55s 5G',
      'Sony Xperia 10 III Lite',
      'Sony Xperia 10 IV',
      'Xperia 10V',
      'Xperia 1 IV',
      'Sony Xperia 5 IV',
      'Sony Xperia 1 V',
      'Sony Xperia Ace III',
      'Sony Xperia 5 V',
      'Xiaomi 12T Pro',
      'Xiaomi 13, 13 Lite, 13 Pro, 13T Pro',
      'Huawei P40, P40 Pro',
      'Huawei Mate 40 Pro',
      'Huawei Mate Xs, Xs2',
      'Huawei P70, P70 Pro and P70 Art',
      'Motorola Razr 2019, Razr 5G',
      'Motorola Razr 40, Razr 40 Ultra',
      'Motorola Razr+',
      'Motorola Edge+',
      'Motorola Edge 40, Edge 40 Pro, Edge 40 Neo',
      'Motorola G52J 5G',
      'Motorola G52J 5G Ⅱ',
      'Motorola G53J 5G',
      'Moto G54 5G',
      'Motorola G84',
      'Samsung Galaxy S24, S24 Plus, S24 Ultra, S24 FE',
      'Samsung Galaxy Fold',
      'Samsung Galaxy Z Fold2 5G',
      'Samsung Galaxy Z Fold3 5G',
      'Samsung Galaxy Z Fold4',
      'Samsung Galaxy Z Fold5 5G',
      'Samsung Galaxy Z Fold6 5G',
      'Samsung Galaxy Z Flip',
      'Samsung Galaxy Z Flip3 5G',
      'Samsung Galaxy Z Flip4',
      'Samsung Galaxy Z Flip5 5G',
      'Samsung Galaxy Z Flip6 5G',
      'Samsung Galaxy A55 5G',
      'Samsung Galaxy A35',
      'Google Pixel 9, 9 Pro, 9 Pro XL',
      'Oppo Find X3, X8, X8 Pro',
      'Oppo Find N3, N3 Flip',
      'Xiaomi 14, 14 Pro, 14T, 14T Pro',
      'Xiaomi Redmi Note 13 Pro+',
      'Motorola Edge 2022, Edge 2023, Edge+ 2023',
      'Motorola Edge 50 Pro, Ultra, Fusion',
      'Motorola Moto G Power 5G',
      'Motorola G34',
      'Motorola Razr 2024, Razr+ 2024',
      'Motorola Moto G Stylus 5G 2024',
      'Honor Magic 4 Pro, 5 Pro, 6 Pro',
      'Honor 90',
      'Honor X8',
      'Honor 200, 200 Pro',
      'Honor Magic V2, V3',
      'OnePlus 11, 12 ,13',
      'Nokia XR21, X30, g60',
      'Vivo X80 Pro, X90 pro, X100 Pro',
      'Vivo V29, V29 Lite, V29 Lite 5G',
      'Vivo V40, V40 Lite, V40 SE',
      'OUKITEL WP30 Pro, WP33 Pro',
      'Nuu X5',
      'ZTE Nubia Flip',
      'TLC 50 5G',
      'Asus ROG Phone 9, 9 Pro',
      'HAMMER Blade 3, 5G',
      'HAMMER Explorer PRO',
      'Gemini PDA',
      'Fairphone 4, 5',
      'DOOGEE V30',
      'Sharp AQUOS sense4 lite, Sense6s, sense 7, sense 7plus',
      'Sharp AQUOS Wish, Wish 2, wish 3',
      'AQUOS zero 6',
      'Simple Sumaho6',
      'Sharp AQUOS R7, R8, R8 Pro',
      'Rakuten Mini',
      'Rakuten Big, Big-S',
      'Rakuten Hand, Hand 5G'
    ];  


  @ViewChild('eSimSuccessModal') eSimSuccessModal: any;
  @ViewChild('devicesModal') devicesModal: any;

  constructor(
    public router: Router,
    public toast: ToastrService,
    private _location: Location,
    public cardService: CardService,
    private modalService: NgbModal,
    public updateProfileService: UpdateProfileService,
  ) { }

  ngOnInit(): void {
   
    this.orderData = JSON.parse(sessionStorage.getItem(ConstantsKey.ADD_ON_ORDER_TYPE));
    this.orderType = this.orderData.orderType;
    this.eSIMSelectedPackage = JSON.parse(sessionStorage.getItem(ConstantsKey.SELECTED_ESIM));
    console.log(this.eSIMSelectedPackage);

    this.getProfileList();

  }



  goTobuyesim(orderType){
    // let orderData = {"order":"esim", "orderType": orderType };
    // sessionStorage.setItem(ConstantsKey.ADD_ON_ORDER_TYPE, JSON.stringify(orderData));

    // this.router.navigate(['/buy-international-esim']);
  }

  letterOnly(event: KeyboardEvent) {
    var charCode = event.keyCode;
    if (((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8) || charCode == 32)
      return true;
    else return false;
  }


  onSubmit(form: any) {
    if (form.valid) {
      let packageId  = this.eSIMSelectedPackage["package_id"];
      let claimReqObject = {
        packageId: packageId,
        firstName: this.firstName,
        lastName: this.lastName,
        address: this.address,
        city: this.city,
        state: this.state,
        emailId: this.email,    
        mobile: this.mobileNo,
        pan: this.panCard,
        simType: this.simType
    };
      if(this.orderType == "BUY") {

        // this.router.navigate(['/link-buy-esim']);
        this.placeESimOrderProceed();
      } else if(this.orderType == "CLAIM") {
        this.claimSimCard();
      }

    } else {
      form.form.markAllAsTouched(); 
    }
  }

  placeESimOrderProceed() {

    let packageId  = this.eSIMSelectedPackage["id"];

    let packageReqData = sessionStorage.getItem(ConstantsKey.SELECTED_ESIM_REQUEST);        
    if(packageReqData) {
      packageReqData = JSON.parse(packageReqData);
    }

    let orderPlaceReques = {
      packageId: packageId,
      firstName: this.firstName,
      lastName: this.lastName,
      address: this.address,
      city: this.city,
      state: this.state,
      emailId: this.email,    
      mobile: this.mobileNo,
      countryCode: packageReqData["countryCode"],
      days: packageReqData["duration"],
      pan: this.panCard,
      simType: this.simType
  };

    this.cardService.placeOrderForEsim(orderPlaceReques).subscribe(resp => {

      let respObj = resp.body;
      sessionStorage.setItem(ConstantsKey.ESIM_ORDER_DATA, JSON.stringify(respObj));
      this.router.navigate(['/link-buy-esim']);

    }, err => {
      this.showLoader = false;
      console.log(err);
      this.toast.error(err.error.message);
    });

  }


  claimSimCard() {

    let packageId  = this.eSIMSelectedPackage["id"];
  
    let claimReqObject = {
        packageId: packageId,
        firstName: this.firstName,
        lastName: this.lastName,
        address: this.address,
        city: this.city,
        state: this.state,
        emailId: this.email,    
        mobile: this.mobileNo,
        pancard: this.panCard,
        simType: ''
    };
    this.cardService.buyEsimPackage(claimReqObject).subscribe(resp => {
      this.openSuccessModal();

    }, err => {
      this.showLoader = false;
      console.log(err);
      this.toast.error(err.error.message);
    });
  }

  closeModalAndNavigate() {
    this.modalService.dismissAll();
    this.router.navigate(['/add-on/order-list/esim']);
  }

  openSuccessModal() {
    this.modalService.open(this.eSimSuccessModal , { centered: true , size: 'md'});
  }

  getProfileList() {
    this.showLoader = true;
    this.updateProfileService.getProfileListAll().subscribe(resp => {
      this.showLoader = false;

      this.consumerDetail = resp.body;
      this.firstName = this.consumerDetail?.firstName;
      this.lastName = this.consumerDetail?.lastName;
      this.email = this.consumerDetail?.email;
      this.mobileNo = this.consumerDetail?.paxResponse.mobile;
      this.panCard = this.consumerDetail?.panNumber;
    }, error => {
      this.showLoader = false;
      // this.toast.error(error.error.message);
    });
  }


  opendevicesModal() {
    this.modalService.open(this.devicesModal, { size: 'sm', windowClass: 'centered-modal' });
  }

}
